export const PLAN_MAP = {
  bottomlessCup: ['drink', 'alcohol'],
  lambFree: ['lamb-menu'],
  'nonbe-course': ['drink', 'alcohol'],
  '3000-yen-course-bottomlesscup': ['drink', 'alcohol'],
  '3000-yen-course-softdrink': ['drink'],
  '5000-yen-course-bottomlesscup': ['drink', 'alcohol'],
  '5000-yen-course-softdrink': ['drink'],
  '8000-yen-course-bottomlesscup': ['drink', 'alcohol'],
  '8000-yen-course-softdrink': ['drink'],
  'softdrink-bottomlesscup': ['drink'],
  //再生酒場
  'saisei-cospa-course': ['drink', 'alcohol'],
  'saisei-choi-course': ['drink', 'alcohol'],
};

export const PLAN_TIME_LIMITS = {
  bottomlessCup: 90,
  lambFree: 45,
  'nonbe-course': 90,
  '3000-yen-course-bottomlesscup': 90,
  '5000-yen-course-bottomlesscup': 90,
  '8000-yen-course-bottomlesscup': 90,
  'softdrink-bottomlesscup': 90,
  //再生酒場
  'saisei-cospa-course': 120,
  'saisei-choi-course': 120,
};
